module.exports = __webpack_public_path__ + "img/face2@2x.65e982b8.png";